<template>
    <iframe
        v-if='media && media.type == "pdf"'
        v-show='selected >= (images.length - 1)'
        :src="'/build/pdf/web/viewer.html?file=' + media.full_path"
        width="100%"
        height="100%">
    </iframe>
</template>

<script>
    export default {
        props: ['media', 'selected', 'images']
    }
</script>

<style scoped>
    .test {
        color: white;
    }

    iframe {
        width: 100%;
        height: 100%;
        border: none;
    }
</style>
